import { useEffect, useRef, useState } from "react";
import { PiSealCheck } from "react-icons/pi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useDispatch } from "react-redux";
import imagePlaceHolder from "../../../../assets/images/imageplace.jpg";
import {
  InputField,
  Modal,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import styles from "./EditBusProfileModal.module.css";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";

const EditBusProfileModal = ({
  editBusinessProfile,
  setEditBusinessProfile,
  businessDetails,
}) => {
  const dispatch = useDispatch();
  const [percent, setPercent] = useState(50);
  const { width } = useWindowDimensions();
  const [name, setName] = useState(
    businessDetails?.name ? businessDetails?.name : "",
  );
  const [email, setEmail] = useState(
    businessDetails?.email ? businessDetails?.email : "",
  );
  const [address, setAddress] = useState(
    businessDetails?.address ? businessDetails?.address : "",
  );
  const [contactNo, setContactNo] = useState(
    businessDetails?.contact_no ? businessDetails?.contact_no : "",
  );
  const [businessYears, setBusinessYears] = useState(
    businessDetails?.years ? businessDetails?.years : "",
  );
  const [description, setDescription] = useState(
    businessDetails?.service_description
      ? businessDetails?.service_description
      : "",
  );
  const [identificationNo, setIdentificationNo] = useState(
    businessDetails?.tax_identification_no
      ? businessDetails?.tax_identification_no
      : "",
  );
  const [licenseNo, setLicenseNo] = useState(
    businessDetails?.business_license_no
      ? businessDetails?.business_license_no
      : "",
  );
  // const [dealerId, setDealerId] = useState(
  //   businessDetails?.dealer_id ? businessDetails?.dealer_id : "",
  // );

  const [companyLogo, setCompanyLogo] = useState(null);
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);

  const hiddenFileInput = useRef();
  const handleFileHandler = () => {
    hiddenFileInput.current.click();
  };

  useEffect(() => {
    if (businessDetails) {
      setName(businessDetails?.name || "");
      setEmail(businessDetails?.email || "");
      setAddress(businessDetails?.address || "");
      setContactNo(businessDetails?.contact_no || "");
      setBusinessYears(businessDetails?.years || "");
      setDescription(businessDetails?.service_description || "");
      setIdentificationNo(businessDetails?.tax_identification_no || "");
      setLicenseNo(businessDetails?.business_license_no || "");
      // setDealerId(businessDetails?.dealer_id || "");
      setCompanyLogo(null);
    }
    if (!editBusinessProfile) {
      setName("");
      setEmail("");
      setAddress("");
      setContactNo("");
      setBusinessYears("");
      setDescription("");
      // setDealerId("");
      setCompanyLogo(null);
    }
  }, [!editBusinessProfile]);

  const onUpdateProfile = () => {
    let userData = {
      name,
      email,
      address,
      contactNo,
      businessYears,
      description,
      identificationNo,
      licenseNo,
      // dealerId,
      logo: companyLogo ? companyLogo : null,
    };
    if (
      !name ||
      !email ||
      !address ||
      !contactNo ||
      !businessYears ||
      !description ||
      !identificationNo ||
      !licenseNo
      // || !dealerId
    ) {
      dispatch(
        showAlert({
          type: "warning",
          message: "All fields are required",
        }),
      );
    } else {
      dispatch(AuthMiddleware.updateCompanyProfile(userData))
        .then(() => {
          setEditBusinessProfile(false);
          setIsSuccessFulModal(true);
        })
        .catch(() => {});
    }
  };
  return (
    <>
      <Modal
        width={"600px"}
        open={editBusinessProfile}
        onCancel={() => setEditBusinessProfile(false)}
      >
        <div className={styles.mainCont}>
          <div className={styles.textDiv}>
            <div className={styles.welcomeDiv}>
              <TextComponent
                className={styles.welcomeHeading}
                text={"Edit Profile"}
              />
              {/* <Flex gap={10} vertical style={{ marginLeft: "10px" }}>
              <Progress
                showInfo={false}
                trailColor={"var(--light-blue)"}
                strokeLinecap={"round"}
                strokeColor={"var(--secondary-color)"}
                percent={percent}
                steps={2}
                size={{ width: width < 500 ? 50 : 100, height: 8 }}
                className={styles.progressBar}
                //   style={{width: "100px", height: "6px", borderRadius: "10px"}}
              />
            </Flex> */}
            </div>
            <TextComponent
              className={styles.welcomeText}
              text={"Update profile information"}
            />
          </div>
          {/* {percent == 50 ? (
          <> */}
          <div className={styles.profileImg}>
            <img
              src={
                companyLogo
                  ? URL.createObjectURL(companyLogo)
                  : businessDetails?.logo
                    ? businessDetails?.logo
                    : imagePlaceHolder
              }
              style={{ objectFit: "contain" }}
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setCompanyLogo(e.target.files[0])}
              ref={hiddenFileInput}
              style={{ display: "none" }}
            />
            <div className={styles.opacityCont}></div>
            <div className={styles.changeImageDiv}>
              <TextComponent
                text={companyLogo ? "Change" : "Upload"}
                className={
                  companyLogo ? styles.changeText : styles.changeTextUpload
                }
                onClick={handleFileHandler}
              />
              <div
                className={styles.deleteCont}
                style={{ display: !companyLogo && "none" }}
                onClick={() => setCompanyLogo()}
              >
                <RiDeleteBin6Line size={18} color={"var(--primary-color)"} />
              </div>
            </div>
          </div>
          <div style={{ margin: "20px 0" }} className={styles.inputDiv}>
            <InputField
              value={name}
              onChange={(e) => setName(e.target.value)}
              label={"Business Name"}
              placeholder={"Write here"}
            />
            <InputField
              value={email}
              // onChange={(e) => setEmail(e.target.value)}
              label={"Business Email"}
              placeholder={"Write here"}
              disabled={true}
            />
            <PhoneInput
              label={"Primary Contact Number"}
              placeholder={"Write here"}
              // className={styles.input}
              value={contactNo}
              onChange={setContactNo}
            />
            <InputField
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              label={"Business Address"}
              placeholder={"Write here"}
            />
            {/* <InputField
              value={dealerId}
              onChange={(e) => setDealerId(e.target.value)}
              label={"Dealer ID"}
              placeholder={"Write here"}
            /> */}
          </div>
          {/* <div>
              <SubmitButton
                title={"Next"}
                onClick={() => {
                  setPercent(100);
                }}
              />
              <SubmitButton
                title={"Go Back"}
                onClick={() => setEditBusinessProfile(false)}
                secondaryBtn
                style={{ marginTop: "10px" }}
              />
            </div> */}
          {/* </> */}
          {/* ) : (
          <> */}
          <div style={{ margin: "20px 0" }} className={styles.inputDiv}>
            <InputField
              className={styles.input}
              label={"Tax Identification Number"}
              placeholder={"Write here"}
              value={identificationNo}
              onChange={(e) => setIdentificationNo(e.target.value)}
              maxLength={15}
            />
            <InputField
              className={styles.input}
              label={"Business License Number"}
              placeholder={"Write here"}
              value={licenseNo}
              onChange={(e) => setLicenseNo(e.target.value)}
              maxLength={25}
            />
            <InputField
              value={businessYears}
              onChange={(e) => setBusinessYears(e.target.value)}
              label={"Years in business"}
              placeholder={"Write here"}
            />
            <InputField
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              label={"Description of services"}
              placeholder={"Write here"}
            />
          </div>
          <div>
            <SubmitButton title={"Save changes"} onClick={onUpdateProfile} />
            {/* <SubmitButton
                title={"Go Back"}
                onClick={() => {
                  setPercent(50);
                }}
                secondaryBtn
                style={{ marginTop: "10px" }}
              /> */}
          </div>
          {/* </>
        )} */}
        </div>
      </Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Changes saved"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setIsSuccessFulModal(false)}
      ></Modal>
    </>
  );
};

export default EditBusProfileModal;
